import React, { useState } from "react";
import ProductImages from "components/product/images";
import Money from "components/money";
import Link from "components/link";
import { useCart, useCustomer } from "hooks/useStore";
import useToggle from "hooks/useToggle";
import { trackAddToCart, trackSelectItem } from "analytics";
import clsx from "clsx/lite";
import Loader from "components/loader";
import getProductUrl from "utils/product-url";
import usePostATCAction from "hooks/usePostATCAction";

const RecentlyViewedItem = ({ product }) => {
	const [selectedVariant, setSelectedVariant] =
		useState(product.variants.find(variant => variant.isAvailable) || product.variant);
	const [isLoading, toggleLoading] = useToggle();
	const { addCartItem } = useCart(["addCartItem"]);
	const disabled = !selectedVariant.isAvailable || isLoading;
	const customer = useCustomer();
	const postAddToCartAction = usePostATCAction();

	const handleAddToCart = async () => {
		if (disabled) return;
		toggleLoading();
		await addCartItem(selectedVariant.gid, 1);
		trackAddToCart({ ...product, quantity: 1 }, customer);
		toggleLoading();
		postAddToCartAction();
	};

	return (
		<div className="h-full">
			<Link
				to={getProductUrl(product)}
				tabIndex={0}
				onClick={() => trackSelectItem(product, customer, "recently_viewed")}
				className="group/card flex animate-blurIn flex-col gap-2.5">
				<div className="*:aspect-square">
					<ProductImages product={product} />
				</div>
				<div className="w-full">
					<div className="flex justify-between">
						<p className="text-start line-clamp-2 font-bold leading-none pr-4 text-lg">
							{product.title}
						</p>
						<div className="flex flex-col justify-end min-w-fit items-end">
							<div className="flex items-end justify-end flex-col">
								<p className="font-semibold ml-2 text-base md:text-lg">
									<Money value={selectedVariant?.price} markets={selectedVariant?.markets} />
								</p>
								{selectedVariant?.compareAtPrice > selectedVariant?.price ?
									<span className="line-through text-sm text-secondary">
										<Money value={selectedVariant?.compareAtPrice}
											markets={selectedVariant?.markets} compareAtPrice />
									</span>
									: <span className="h-5" />
								}
							</div>
						</div>
					</div>
				</div>
			</Link>
			<div className="flex flex-col mt-auto">
				{product.variants.length > 1 ?
					<div className="flex py-2">
						<div className="w-full border border-gray-300 py-2 pl-4 pr-2 text-gray-700">
							<select
								onChange={(e) =>
									setSelectedVariant(product.variants.find(variant => +variant.id === +e.target.value))}
								value={+selectedVariant?.id}
								className="recently-view-dropdown">
								{product.variants.map((variant) => {
									return (
										<option key={variant.id} value={+variant.id}>{variant.title}</option>
									);
								})}
							</select>
						</div>
					</div>
					: <span className="h-14" />}
				<button
					disabled={disabled}
					className={clsx("w-full py-3 btn-primary text-base tracking-widest px-2", isLoading && "pointer-events-none")}
					onClick={handleAddToCart}
				>
					{isLoading
						? <Loader className="size-5" ring />
						: <span className="flex justify-center gap-1">
							{selectedVariant?.isAvailable ? "Add to cart " : "Sold out"}
						</span>}
				</button>
			</div>
		</div>
	);
};

export default RecentlyViewedItem;